export function formatTimer(minutesRaw: number) {
  const hours = Math.floor(minutesRaw / 60)
  const minutes = minutesRaw % 60

  return `${hours}h ${String(minutes).padStart(2, '0')}m`
}
